import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Course, CourseTest } from 'src/app/shared/models/course';
import { PrivilegeType } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { CourseService } from 'src/app/shared/services/course.service';
import { DataService } from 'src/app/shared/services/data.service';
import { ExamAttendComponent } from '../exam-attend/exam-attend/exam-attend.component';

@Component({
  selector: 'app-active-course-test-list',
  templateUrl: './active-course-test-list.component.html',
  styleUrls: ['./active-course-test-list.component.scss']
})
export class ActiveCourseTestListComponent implements OnInit {
public courseTests: CourseTest[] = [];
  public courses: Course[] = [];
  public course:Course;
  public courseId: number | null = null;
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;

  constructor(
    private modalService: NgbModal,
    private commonService: CommonService,
    private dataService: DataService,
    private courseService: CourseService,
    private authService:AuthService

  ) { }

  ngOnInit(): void {
    this.courseService.getCourses(false).subscribe((courses: Course[]) => {
      this.courses = courses;
      if (this.courses.length > 0) {
        const selectedCourse = this.courses[0];
        this.courseId = selectedCourse.id;
        this.getCourseTests(this.courseId);
      }else {
        this.courseTests = [];
        this.isLoading = false;
      }
    });
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
  }

  public onCourseChange() {
    this.getCourseTests(this.courseId);
  }

  public getCourseTests(courseId: number) {
    this.course = this.courses.find(c => c.id === courseId) || null;
    this.courseService.getCourseTests(courseId).subscribe({
      next: (courseTests: CourseTest[]) => {
        this.courseTests = courseTests
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.commonService.setToastr(500, error?.error?.name || error.error);
      }
    });
  }
  public attendExam(courseTest: CourseTest) {
    this.courseService.getEmployeeIsAttend(this.authService.getContextData()?.employeeId, courseTest.id)
      .subscribe({
        next: (isAllowed: boolean) => {
          if (isAllowed) {
            this.commonService.setToastr(400, "You are not allowed to attend this exam.");
            return;
          }
          const modalRef = this.modalService.open(ExamAttendComponent, { size: 'lg',backdrop: 'static' });
          modalRef.componentInstance.courseTest = courseTest;
          modalRef.componentInstance.course = this.course;
          modalRef.componentInstance.context = this.authService.getContextData();
          modalRef.componentInstance.courseTests = this.courseTests.filter(t => t.id !== courseTest.id);
        },
        error: (error: HttpErrorResponse) => {
        }
      });
  }
  
  public getTruncatedName(name: string, maxLength: number): string {
    if (name.length > maxLength) {
      return name.slice(0, maxLength) + '...';
    }
    return name;
  }
}
